import React from 'react';
import { Button } from './Button';
import { SectionWrapper } from './SectionWrapper';
import ShieldIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import BoltIcon from '@mui/icons-material/Bolt';
import SpaIcon from '@mui/icons-material/Spa';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import StarIcon from '@mui/icons-material/Star';
export function HeroSection() {
  return <SectionWrapper className="pt-8 md:pt-12 bg-secondary" data-id="element-119">
      <div className="text-center mb-4" data-id="element-120">
        <span className="inline-block py-1 px-3 rounded-full bg-primary/10 text-primary font-semibold mb-2 tracking-wide uppercase text-[11px]" data-id="element-121">
          Todo lo que necesitás para resetear tu digestión.
        </span>
        <h1 className="font-serif md:text-6xl font-bold text-primary mb-2 text-[32px]" data-id="element-122">
          Reinicio Interno
        </h1>
        <h2 className="md:text-2xl text-gray-700 font-medium mb-4 text-[15px]" data-id="element-123">
          LISTO DESDE HOY — Kit Completo de Transformación Digestiva
        </h2>

        <div className="max-w-[200px] mx-auto mb-3" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/3uSxY8YoAitkHSC1EgQk7y/Guia_de_desparasitacion_natural_(1).png" alt="Reinicio Interno Kit" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-125" />
        </div>

        <p className="text-gray-600 max-w-2xl mx-auto mb-2 font-medium text-[16px]" data-id="element-126">
          El sistema N°1 para recuperar tu salud digestiva desde adentro — 14
          días — Método META + MACA
        </p>
        <p className="text-gray-600 max-w-3xl mx-auto mb-6 text-[12px]" data-id="element-127">
          Protocolo + recetario + plan de comidas + guía de compras listos para
          aplicar. Sin buscar. Sin improvisar. Sin volver a empezar.
        </p>
      </div>

      <div className="flex justify-center gap-3 mb-3 max-w-sm mx-auto flex-wrap" data-id="element-128">
        <span className="inline-flex items-center gap-1 text-[10px] text-gray-600 font-medium" data-id="element-129">
          <PictureAsPdfIcon className="text-primary" style={{
          fontSize: 12
        }} data-id="element-130" />
          Digital PDF
        </span>
        <span className="inline-flex items-center gap-1 text-[10px] text-gray-600 font-medium" data-id="element-131">
          <BoltIcon className="text-amber-500" style={{
          fontSize: 12
        }} data-id="element-132" />
          Acceso en 5 min
        </span>
        <span className="inline-flex items-center gap-1 text-[10px] text-gray-600 font-medium" data-id="element-133">
          <SpaIcon className="text-green-500" style={{
          fontSize: 12
        }} data-id="element-134" />
          META + MACA
        </span>
        <span className="inline-flex items-center gap-1 text-[10px] text-gray-600 font-medium" data-id="element-135">
          <LibraryBooksIcon className="text-blue-500" style={{
          fontSize: 12
        }} data-id="element-136" />
          1 kit + 5 bonos
        </span>
      </div>

      <div className="flex flex-col items-center text-center mb-6" data-id="element-137">
        <Button className="mb-4 w-full md:w-auto" data-id="element-138">
          → QUIERO MI REINICIO INTERNO AHORA
        </Button>

        <div className="flex flex-wrap justify-center gap-3 text-sm text-gray-600 mb-4" data-id="element-139">
          <span className="flex items-center" data-id="element-140">
            <ShieldIcon fontSize="small" className="mr-1 text-primary" data-id="element-141" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-142">
            <LockIcon fontSize="small" className="mr-1 text-primary" data-id="element-143" /> Pago
            seguro
          </span>
          <span className="flex items-center" data-id="element-144">
            <CreditCardIcon fontSize="small" className="mr-1 text-primary" data-id="element-145" />{' '}
            Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>

        <div className="flex items-center gap-4 bg-white p-3 rounded-xl shadow-sm border border-gray-100 w-full max-w-md" data-id="element-146">
          <div className="flex -space-x-2" data-id="element-147">
            {[1, 2, 3, 4].map(i => <div key={i} className="w-9 h-9 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs font-bold text-gray-500" data-id="element-148">
                {String.fromCharCode(64 + i)}
              </div>)}
          </div>
          <div data-id="element-149">
            <div className="flex text-amber-400 text-sm" data-id="element-150">
              <StarIcon fontSize="inherit" data-id="element-151" />
              <StarIcon fontSize="inherit" data-id="element-152" />
              <StarIcon fontSize="inherit" data-id="element-153" />
              <StarIcon fontSize="inherit" data-id="element-154" />
              <StarIcon fontSize="inherit" data-id="element-155" />
            </div>
            <p className="text-sm font-bold text-gray-800" data-id="element-156">
              4.9/5 calificación
            </p>
            <p className="text-xs text-gray-500" data-id="element-157">+500 personas ya iniciaron</p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}